import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  buttoncountcontainer: {
    marginTop: 15,
    marginBottom: 15
  },
  pageContent: {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
    borderRadius: "10px 10px 0px 0px",
    boxSizing: "border-box",
    paddingTop: "10px",
    marginTop: 20
  },
  contentpadding: {
    paddingLeft: 10,
    paddingBottom: 10
  },
  detailstext: {
    textAlign: "left"
  },
  pagedivider: {
    marginTop: 40,
    marginBottom: 40,
    color: "#DFE2E7"
  },
  title: {
    color: "#98A2B3",
    fontSize: 14,
    marginBottom: 3
  },
  subtitle: {
    color: "#40444B",
    fontSize: 14,
    fontWeight: 500
  },
  memberBox: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 8,
    padding: "0.5rem",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.06)",
    marginBottom: "0.5rem",
    backgroundColor: "#fff",
    "&:first-of-type": {
      marginTop: "24px"
    }
  },
  approve: {
    fontWeight: "500",
    textAlign: "left",
    backgroundColor: "#e6eaf0ff",
    borderRadius: "4px",
    color: "#05610bff",
    padding: "20px",
    marginBlock: "0px"
  },
  name: {
    fontWeight: 600,
    fontSize: "1rem"
  },
  role: {
    color: theme.palette.primary.main,
    fontSize: "0.9rem"
  },
  calendar: {
    border: "1px solid #E4E7EC",
    padding: "16px",
    borderRadius: "16px",
    marginTop: "50px",
    backgroundColor: "white"
  } }));
